import { useTranslation } from "react-i18next";
import MainLayout from "../../layouts/MainLayout";
import Footer from "../../containers/Footer";
import { motion } from "framer-motion";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

function OnlineServicesPage() {
  const { t } = useTranslation();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <MainLayout pageCSS="online-service-page">
        <Container>
          <h1>{t("online-service_page_header_1")}</h1>
          <h2>{t("online-service_page_header_2")}</h2>
          <Row className="justify-content-center u-mt-medium">
            <Col className="d-flex align-items-stretch" md={5}>
              <Card>
                <Card.Img
                  src="https://res.cloudinary.com/dnfpmrdjl/image/upload/c_scale,h_378,w_504/v1660330828/bill_jfpoek.jpg"
                  alt="yowa"
                />
                <Card.Body>
                  <Card.Text>
                    {t("online-service_page_invoice_text_body")}
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <Link
                    to="/online-services/invoices"
                    className="btn btn-blue u-mt-small"
                  >
                    {t("online-service_page_invoice_text_button")}
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
            <Col
              md={{ span: 5, offset: 1 }}
              className="d-flex align-items-stretch"
            >
              <Card>
                <Card.Img
                  src="https://res.cloudinary.com/dnfpmrdjl/image/upload/v1661102289/lucian-alexe-p3Ip8U0eNNM-unsplash_1-min_baiaqd.jpg"
                  alt="yowa"
                />
                <Card.Body>
                  <Card.Text>
                    {t("online-service_page_claim_request_text_body")}
                    <br />
                    Source:{" "}
                    <Link to="https://www.assurance-credit-entreprise.fr/glossary/declaration-sinistre/">
                      Assurance Credit Entreprise
                    </Link>
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <Link
                    to="/online-services/claim-report"
                    className="btn btn-blue u-mt-small"
                  >
                    {t("online-service_page_claim_request_text_button")}
                  </Link>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Container>
      </MainLayout>
      <Footer />
    </motion.div>
  );
}

export default OnlineServicesPage;
